import { atom } from "jotai";

const indoorItemNamesAtom = atom<Record<string, string>>();

export default indoorItemNamesAtom;
